// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.menu {
    display: flex;
    color: white;
    padding: 5px 10px;
    border-right: 4px solid transparent;
    transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);
    justify-content: space-between;
    margin-left: -5px !important;
}

.link_text {
    white-space: nowrap;
    font-size: 15px;
}

.menu a  *{
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/Sidebar/index.css"],"names":[],"mappings":";;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,mCAAmC;IACnC,uDAAuD;IACvD,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\n\n\n.menu {\n    display: flex;\n    color: white;\n    padding: 5px 10px;\n    border-right: 4px solid transparent;\n    transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);\n    justify-content: space-between;\n    margin-left: -5px !important;\n}\n\n.link_text {\n    white-space: nowrap;\n    font-size: 15px;\n}\n\n.menu a  *{\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
